import { useMemo } from 'react'
import { Navigate, useNavigate, useParams } from 'react-router-dom'

import {
  FBPageInnerTabsContainer,
  FBPageTableContainer,
} from 'components/FbUI/Page/styles'
import { Tabs } from 'components/FbUI/Tabs'
import { UserTable } from 'features/settings/components/UserTable'
import { InvitationsTable } from 'features/settings/components/InvitationsTable'
import { EmailIntegrationTable } from 'features/settings/components/EmailIntegrationTable'
import { useFeatureFlagService } from 'utils/useFeatureFlagService'
import { useAuth } from 'context/authentication/useAuth'

const DEFAULT_TAB = 'users'

export function UsersSettingsPage() {
  const params = useParams()
  const navigate = useNavigate()
  const tab = params.tab ?? DEFAULT_TAB
  const featureFlags = useFeatureFlagService()
  const { isAdmin } = useAuth()

  const tabs = useMemo(() => {
    const allTabs = [
      { key: 'users', title: 'Users' },
      ...(featureFlags.enableUserTypes && isAdmin
        ? [{ key: 'invitations', title: 'Invitations' }]
        : []),
      ...(featureFlags.enableEmailIntegration
        ? [{ key: 'email-integration', title: 'Email Integration' }]
        : []),
    ]
    return allTabs
  }, [
    featureFlags.enableEmailIntegration,
    featureFlags.enableUserTypes,
    isAdmin,
  ])

  if (params.tab && !tabs.some((t) => t.key === params.tab)) {
    return <Navigate to={`/settings/users/${DEFAULT_TAB}`} replace />
  }

  return (
    <div className="w-full h-full flex flex-col flex-1 min-h-0">
      <FBPageInnerTabsContainer>
        <Tabs
          tabs={tabs}
          selectedTab={tab}
          setSelectedTab={(value) => navigate(`/settings/users/${value}`)}
          tabStyle={{ width: '125px' }}
        />
      </FBPageInnerTabsContainer>
      <FBPageTableContainer hide={tab !== 'users'}>
        <UserTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'invitations'}>
        <InvitationsTable />
      </FBPageTableContainer>
      <FBPageTableContainer hide={tab !== 'email-integration'}>
        <EmailIntegrationTable />
      </FBPageTableContainer>
    </div>
  )
}
